import { LoginForm } from 'src/components';

export const Login = () => {
    return <LoginForm />;
};
